/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Commandautomate1Inputs */



/**
* | output |
* | --- |
* | "Automate command" |
*
* @param {Br_History_Key_Commandautomate1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_commandautomate1 = /** @type {((inputs?: Br_History_Key_Commandautomate1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Commandautomate1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Automate command")
	return /** @type {LocalizedString} */ ("Commande automate")
});
export { br_history_key_commandautomate1 as "br_history_key_commandAutomate" }